export const OtherRequestorGridColumns = [{
    name: "First Name",
    mapping: "firstname",
    minWidth: 120,
    displayTootip: ["firstname"],
}, {
    name: "Last Name",
    mapping: "lastname",
    minWidth: 120,
    displayTootip: ["lastname"],
}, {
    name: "Email",
    mapping: "email",
    minWidth: 200,
    displayTootip: ["email"]
}, {
    name: "Workday ID",
    mapping: "workdayId",
    minWidth: 120,
    displayTootip: ["workdayId"]
}, {
    name: "Spin ID",
    mapping: "spinId",
    minWidth: 120,
    displayTootip: ["spinId"]
}, {
    name: "Application ID",
    mapping: "applicationId",
    minWidth: 130,
    displayTootip: ["applicationId"]
}, {
    name: "Login ID",
    mapping: "loginId",
    minWidth: 120,
    displayTootip: ["loginId"]
}, {
    name: "GUID",
    mapping: "GUID",
    minWidth: 220,
    displayTootip: ["GUID"]
}, {
    name: "Worker Type",
    mapping: "workertype",
    minWidth: 140,
    displayTootip: ["workertype"]
}, {
    name: "Dealer Code",
    mapping: "dealerCode",
    minWidth: 120,
    displayTootip: ["dealerCode"]
}];

export const CustomerDetailsGridColumns = [{
    name: "CUSTID",
    mapping: "custId",
    minWidth: 130,
    displayTootip: ["custId"],
}, {
    name: "First Name",
    mapping: "firstname",
    minWidth: 130,
    displayTootip: ["firstname"],
}, {
    name: "Last Name",
    mapping: "lastname",
    minWidth: 130,
    displayTootip: ["lastname"],
}, {
    name: "Email",
    mapping: "email",
    minWidth: 220,
    displayTootip: ["email"],
}, {
    name: "GUID",
    mapping: "guid",
    minWidth: 250,
    displayTootip: ["guid"],
}, {
    name: "VIN(s)",
    mapping: "vins",
    minWidth: 220,
    displayTootip: ["vins"],
}];

export const TVLAGridColumns = [{
    name: "TC Case #",
    mapping: "tcCaseNumber",
    minWidth: 150,
    displayTootip: ["tcCaseNumber"],
}, {
    name: "VIN(s)",
    mapping: "vins",
    minWidth: 250,
    displayTootip: ["vins"],
}];

export const ListOfFields = [{
    display: 'Request ID',
    mapping: 'dsar_id'
}, {
    display: "Requestor",
    mapping: 'requestor'
}, {
    display: "Request Type",
    mapping: 'ticket_type'
}, {
    display: "Request Status",
    mapping: 'status'
}]

export const ListOfrequestDetails = [{
    display: "Created Date Time",
    mapping: 'created_date_utc',
    tooltip: 'created_date_local'
}, {
    display: "Created By",
    mapping: "creator"
}, {
    display: "VIN Generation",
    mapping: "vin_generation_display",
    type: "custom"
}, {
    display: "Workflow",
    mapping: "workflow"
}, {
    display: "Customer Type",
    mapping: "consumer_type"
}, {
    display: "Language",
    mapping: "language"
}, {
    display: "Personas",
    mapping: "personas"
}]

export const DetailsViewTabs = {
    "cpsrequestjson": {
        "tabname": "VIEW REQUEST",
        "tabtype": "viewrequest"
    },
    "ehrequestdoc" :{
        "tabname": "EH REQUEST WORD DOC",
        "tabtype": 'word',
        "dsarIdPrefix" : "EH_",
        "regenrateAppId" : 47
    },
    "requestworddoc": {
        "tabname": "VIEW REQUEST DOC",
        "tabtype": 'word'
    },
    "wgrequestdoc": {
        "tabname": "WG REQUEST WORD DOC",
        "tabtype": 'word',
        "dsarIdPrefix" : "WG_",
        "regenrateAppId" : 45
    },
    "subarurequestjson": {
        "tabname": "VIEW SUBARU REQUEST",
        "tabtype": "viewsubarurequest"
    },
    "upstreamrequestjson": {
        "tabname": "VIEW UPSTREAM REQUEST",
        "tabtype": "viewupstreamrequest"
    },
    "wovenrequestjson": {
        "tabname": "VIEW WOVEN REQUEST",
        "tabtype": "viewwovenrequest"
    },
    "viewnonpijson" :{
        "tabname": "VIEW NON PI REQUEST",
        "tabtype" : "viewnonpijson"
    }
}
export const ViewRequestOptions = [{
    name: "CPS Request JSON",
    mapping: "cpsrequestjson"
},{
    name : "EH Request Word Doc",
    mapping : "ehrequestdoc",
    restrictAppId : 47,
    isHidden : true
},{
    name : "Non PI Request JSON",
    mapping: "viewnonpijson"
},{
    name: "Request Word Doc",
    mapping: "requestworddoc"
},
{
    name: "Upstream Request JSON",
    mapping: "upstreamrequestjson"
},{
    name : "WG Request Word Doc",
    mapping : "wgrequestdoc",
    restrictAppId : 45,
    isHidden : true
}]